import { Customer, Loan, Payment, InterestCalculation, Reminder, OutstandingSummary, DashboardMetrics } from '../models/LendingModels';

// Mock Customers
export const mockCustomers: Customer[] = [
  {
    id: '1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@email.com',
    phone: '+1-555-0123',
    address: {
      street: '123 Main St',
      city: 'New York',
      state: 'NY',
      zipCode: '10001',
      country: 'USA'
    },
    dateOfBirth: new Date('1985-03-15'),
    ssn: '123-45-6789',
    creditScore: 750,
    employmentStatus: 'employed',
    monthlyIncome: 5000,
    status: 'active',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-15'),
    createdBy: 'admin',
    updatedBy: 'admin'
  },
  {
    id: '2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.johnson@email.com',
    phone: '+1-555-0124',
    address: {
      street: '456 Oak Ave',
      city: 'Los Angeles',
      state: 'CA',
      zipCode: '90210',
      country: 'USA'
    },
    dateOfBirth: new Date('1990-07-22'),
    ssn: '987-65-4321',
    creditScore: 680,
    employmentStatus: 'self-employed',
    monthlyIncome: 3500,
    status: 'active',
    createdAt: new Date('2024-02-10'),
    updatedAt: new Date('2024-02-10'),
    createdBy: 'admin',
    updatedBy: 'admin'
  },
  {
    id: '3',
    firstName: 'Michael',
    lastName: 'Brown',
    email: 'michael.brown@email.com',
    phone: '+1-555-0125',
    address: {
      street: '789 Pine St',
      city: 'Chicago',
      state: 'IL',
      zipCode: '60601',
      country: 'USA'
    },
    dateOfBirth: new Date('1978-11-08'),
    ssn: '456-78-9012',
    creditScore: 720,
    employmentStatus: 'employed',
    monthlyIncome: 4200,
    status: 'active',
    createdAt: new Date('2024-01-20'),
    updatedAt: new Date('2024-01-20'),
    createdBy: 'admin',
    updatedBy: 'admin'
  }
];

// Mock Loans
export const mockLoans: Loan[] = [
  {
    id: '1',
    customerId: '1',
    loanNumber: 'LN-2024-001',
    principalAmount: 25000,
    interestRate: 8.5,
    interestType: 'compound',
    interestCalculationMethod: 'monthly',
    loanTerm: 36,
    startDate: new Date('2024-01-15'),
    maturityDate: new Date('2027-01-15'),
    status: 'active',
    loanType: 'personal',
    purpose: 'Home improvement',
    createdAt: new Date('2024-01-15'),
    updatedAt: new Date('2024-01-15'),
    createdBy: 'admin',
    updatedBy: 'admin'
  },
  {
    id: '2',
    customerId: '2',
    loanNumber: 'LN-2024-002',
    principalAmount: 15000,
    interestRate: 12.0,
    interestType: 'simple',
    interestCalculationMethod: 'monthly',
    loanTerm: 24,
    startDate: new Date('2024-02-10'),
    maturityDate: new Date('2026-02-10'),
    status: 'active',
    loanType: 'business',
    purpose: 'Small business expansion',
    collateral: {
      type: 'Equipment',
      value: 20000,
      description: 'Restaurant equipment and furniture'
    },
    createdAt: new Date('2024-02-10'),
    updatedAt: new Date('2024-02-10'),
    createdBy: 'admin',
    updatedBy: 'admin'
  },
  {
    id: '3',
    customerId: '3',
    loanNumber: 'LN-2024-003',
    principalAmount: 50000,
    interestRate: 6.5,
    interestType: 'compound',
    interestCalculationMethod: 'monthly',
    loanTerm: 60,
    startDate: new Date('2024-01-20'),
    maturityDate: new Date('2029-01-20'),
    status: 'active',
    loanType: 'auto',
    purpose: 'Vehicle purchase',
    collateral: {
      type: 'Vehicle',
      value: 55000,
      description: '2024 Toyota Camry'
    },
    createdAt: new Date('2024-01-20'),
    updatedAt: new Date('2024-01-20'),
    createdBy: 'admin',
    updatedBy: 'admin'
  }
];

// Mock Payments
export const mockPayments: Payment[] = [
  {
    id: '1',
    loanId: '1',
    customerId: '1',
    paymentNumber: 1,
    amount: 785.50,
    principalAmount: 607.50,
    interestAmount: 178.00,
    paymentDate: new Date('2024-02-15'),
    dueDate: new Date('2024-02-15'),
    status: 'paid',
    paymentMethod: 'bank_transfer',
    referenceNumber: 'TXN-001',
    createdAt: new Date('2024-02-15'),
    updatedAt: new Date('2024-02-15'),
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '2',
    loanId: '1',
    customerId: '1',
    paymentNumber: 2,
    amount: 785.50,
    principalAmount: 611.80,
    interestAmount: 173.70,
    paymentDate: new Date('2024-03-15'),
    dueDate: new Date('2024-03-15'),
    status: 'paid',
    paymentMethod: 'bank_transfer',
    referenceNumber: 'TXN-002',
    createdAt: new Date('2024-03-15'),
    updatedAt: new Date('2024-03-15'),
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '3',
    loanId: '2',
    customerId: '2',
    paymentNumber: 1,
    amount: 750.00,
    principalAmount: 600.00,
    interestAmount: 150.00,
    paymentDate: new Date('2024-03-10'),
    dueDate: new Date('2024-03-10'),
    status: 'paid',
    paymentMethod: 'check',
    referenceNumber: 'CHK-001',
    createdAt: new Date('2024-03-10'),
    updatedAt: new Date('2024-03-10'),
    createdBy: 'system',
    updatedBy: 'system'
  },
  {
    id: '4',
    loanId: '3',
    customerId: '3',
    paymentNumber: 1,
    amount: 975.00,
    principalAmount: 729.17,
    interestAmount: 245.83,
    paymentDate: new Date('2024-02-20'),
    dueDate: new Date('2024-02-20'),
    status: 'paid',
    paymentMethod: 'bank_transfer',
    referenceNumber: 'TXN-003',
    createdAt: new Date('2024-02-20'),
    updatedAt: new Date('2024-02-20'),
    createdBy: 'system',
    updatedBy: 'system'
  }
];

// Mock Interest Calculations
export const mockInterestCalculations: InterestCalculation[] = [
  {
    id: '1',
    loanId: '1',
    calculationDate: new Date('2024-04-01'),
    principalAmount: 23800.70,
    interestRate: 8.5,
    interestAmount: 168.67,
    totalOutstanding: 23969.37,
    daysElapsed: 30,
    calculationMethod: 'monthly',
    createdAt: new Date('2024-04-01')
  },
  {
    id: '2',
    loanId: '2',
    calculationDate: new Date('2024-04-01'),
    principalAmount: 14400.00,
    interestRate: 12.0,
    interestAmount: 144.00,
    totalOutstanding: 14544.00,
    daysElapsed: 30,
    calculationMethod: 'monthly',
    createdAt: new Date('2024-04-01')
  },
  {
    id: '3',
    loanId: '3',
    calculationDate: new Date('2024-04-01'),
    principalAmount: 49270.83,
    interestRate: 6.5,
    interestAmount: 266.88,
    totalOutstanding: 49537.71,
    daysElapsed: 30,
    calculationMethod: 'monthly',
    createdAt: new Date('2024-04-01')
  }
];

// Mock Reminders
export const mockReminders: Reminder[] = [
  {
    id: '1',
    loanId: '1',
    customerId: '1',
    reminderType: 'payment_due',
    dueDate: new Date('2024-04-15'),
    amount: 785.50,
    status: 'pending',
    message: 'Payment of $785.50 is due on April 15, 2024 for loan LN-2024-001',
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-04-01')
  },
  {
    id: '2',
    loanId: '2',
    customerId: '2',
    reminderType: 'payment_due',
    dueDate: new Date('2024-04-10'),
    amount: 750.00,
    status: 'sent',
    message: 'Payment of $750.00 is due on April 10, 2024 for loan LN-2024-002',
    sentDate: new Date('2024-04-05'),
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-04-05')
  },
  {
    id: '3',
    loanId: '3',
    customerId: '3',
    reminderType: 'interest_accrual',
    dueDate: new Date('2024-04-20'),
    amount: 266.88,
    status: 'pending',
    message: 'Interest of $266.88 has accrued for loan LN-2024-003',
    createdAt: new Date('2024-04-01'),
    updatedAt: new Date('2024-04-01')
  }
];

// Mock Outstanding Summaries
export const mockOutstandingSummaries: OutstandingSummary[] = [
  {
    customerId: '1',
    totalOutstanding: 23969.37,
    principalOutstanding: 23800.70,
    interestOutstanding: 168.67,
    overdueAmount: 0,
    nextPaymentDue: new Date('2024-04-15'),
    daysOverdue: 0,
    lastUpdated: new Date('2024-04-01')
  },
  {
    customerId: '2',
    totalOutstanding: 14544.00,
    principalOutstanding: 14400.00,
    interestOutstanding: 144.00,
    overdueAmount: 0,
    nextPaymentDue: new Date('2024-04-10'),
    daysOverdue: 0,
    lastUpdated: new Date('2024-04-01')
  },
  {
    customerId: '3',
    totalOutstanding: 49537.71,
    principalOutstanding: 49270.83,
    interestOutstanding: 266.88,
    overdueAmount: 0,
    nextPaymentDue: new Date('2024-04-20'),
    daysOverdue: 0,
    lastUpdated: new Date('2024-04-01')
  }
];

// Mock Dashboard Metrics
export const mockDashboardMetrics: DashboardMetrics = {
  totalOutstanding: 88051.08,
  totalActiveLoans: 3,
  totalCustomers: 3,
  overduePayments: 0,
  monthlyInterestAccrued: 579.55,
  averageLoanAmount: 30000,
  defaultRate: 0,
  collectionRate: 100
};
